<template>
  <div>
    <div class="box">
      <div id="mapChart" class="chart">
      </div>
      <div>
        <map-range :city-id="code" :cityName="cityName" :city-map="cityMap" @search="search" @getCheckbox="getCheckbox"/>
      </div>
    </div>
  </div>
</template>

<script>




import echarts from "echarts";
import axios from "axios";
import MapRange from './MapRange'


var chinaName = "全国";
var parentId = null;
var parentName = null;
var myChart = null;
export default {
  name: "Map",
  components: {
    MapRange
  },
  props: {
    msg: String
  },
  data() {
    return {
      chinaId: '100000_full',
      cityId : '100000',
      code: '100000',
      cityName: '全国',
      cityJson: null,
      cityMap: [],
      parentCode: null,
      mapStack: [],
      cityLevel: null,
      checkboxFlag: true,
      geoJson: null,
      level: 'country',
      backName: null
    }
  },
  watch: {
    cityId:{
      handler:function(val){
        val = val.toString()
        this.code = val.slice(0,6)
      },
      deep:true//对象内部的属性监听，也叫深度监听
    },
    checkboxFlag:{
      handler:function(){
        this.mapChart("mapChart");
      },
      deep:true//对象内部的属性监听，也叫深度监听
    }
  },
  mounted() {
    this.mapChart("mapChart");
    document.getElementById("mapChart").addEventListener('dblclick',this.back)


  },
  created() {
    var this_ = this
    axios.get('/json/map/adcode-map.json').then(response => {
      this_.cityJson = response
      for (let i = 0; i < this.cityJson.data.length; i++) {
          this.cityMap.push(this.cityJson.data[i].name + "(" + this.cityJson.data[i]["adcode"] + ")")
      }
    })

  },
  methods: {
    getCheckbox(val){
      this.checkboxFlag = val
    },
    /**
     * 返回上一级地图
     */
    back() {
      if (this.mapStack.length !== 0) {
        //如果有上级目录则执行
        var map = this.mapStack.pop();
        if (this.checkboxFlag === true) {
          map.mapId = map.mapId + '_full'
        }
        this.getBackId(map.mapId)
        axios
          .get("/json/map/" + map.mapId + ".json", {})
          .then(response => {
            const mapJson = response.data;
            this.registerAndsetOption(
              myChart,
              map.mapId,
              map.mapName,
              mapJson,
              false
            );
            //返回上一级后，父级的ID、Name随之改变
            if (parentId !== null) {
              this.getBackName(parentId)
              parentName = this.backName
              this.mapStack.pop()
              this.mapStack.push({
                mapId: parentId,
                mapName: parentName
              });
            }
            this.cityId = map.mapId
            this.cityName = map.mapName;
          });
      }
    },
    registerAndsetOption(myChart, id, name, mapJson, flag) {
        myChart.clear()
      echarts.registerMap(name, mapJson);
      myChart.setOption({
        series: [
          {
            type: "map",
            map: name,
            roam: true,
            itemStyle: {
              normal: {
                areaColor: '#fff',
                borderColor: '#000',
                borderWidth: 0.5,
                borderType: 'solid',
                label: {
                  show: false,
                }
              },
              emphasis: {
                areaColor: 'rgb(204,235,235)',
                borderColor: 'rgb(40,154,154)',
                borderType: 'solid',
                label: {
                  show: true,
                  position: 'top',
                  // position: ["0%","50%"],
                  distance: 20,
                  formatter: function (params){
                    return "adcode: " + '{value|'+ params.data.value + '}'+ "\nname: " + '{name|'+ params.data.name + '}' + "\nlevel: " + '{level|'+params.data.level + '}'
                  },
                  rich: {
                    value:{
                      color: 'rgb(1,200,200)'
                    },
                    name:{
                      color: 'rgb(1,200,200)'
                    },
                    level:{
                      color: 'rgb(1,200,200)'
                    }
                  },
                  textStyle: {
                    color: "rgb(232,232,232)",
                    align: 'left',
                    backgroundColor: 'rgb(0,0,0)',
                    padding: [5,12],
                    lineHeight: 30,
                    borderRadius: 10,
                    fontSize: 16
                  }
                }
              }
            },
            data: this.initMapData(mapJson)
          }
        ]
      });

      if (flag) {
        //往mapStack里添加parentId，parentName,返回上一级使用
        this.getBackName(parentId)
        parentName = this.backName
        this.mapStack.pop()
        this.mapStack.push({
          mapId: parentId,
          mapName: parentName
        });
      }
    },
    initMapData(mapJson) {
      var mapData = [];
      for (var i = 0; i < mapJson.features.length; i++) {
        for (let j = 0; j < this.cityJson.data.length; j++) {
          if (this.cityJson.data[j]["name"] === mapJson.features[i].properties.name) {
            mapData.push({
              name: mapJson.features[i].properties.name,
              value: this.cityJson.data[j]["adcode"],
              level: this.cityJson.data[j]["level"]
            });
          }
        }

      }

      return mapData;
    },
    mapChart(divid) {
      var this_ = this
      if (this_.checkboxFlag && this_.level !== "district") {
        this_.cityId = this_.cityId.toString().slice(0,6) + "_full"
      }else{
        this_.cityId = this_.cityId.toString().slice(0,6)
      }
      axios.get("/json/map/" + this_.cityId + ".json", {}).then(response => {
        const mapJson = response.data;
        this_.geoJson = mapJson
        myChart = echarts.init(document.getElementById(divid));
        this_.registerAndsetOption(myChart, this_.cityId, chinaName, mapJson, false);

        myChart.on("click", function(param) {
          let index = 0
          for (let i = 0; i < this_.cityJson.data.length; i++) {
            if (this_.cityJson.data[i]["name"] === param.name) {
              this_.level = this_.cityJson.data[i]["level"]
              index = i
              if (this_.checkboxFlag && this_.level !== "district") {
                this_.parentCode = this_.cityJson.data[i]["adcode"] + "_full"
              }else{
                this_.parentCode = this_.cityJson.data[i]["adcode"]
              }

              this_.cityName = param.name
            }
          }
          if (this_.parentCode !== this_.cityId) {
            if (!(this_.parentCode.toString().slice(2, 6) === "0000" || this_.parentCode.toString().slice(4, 6) === "00") || this_.level === "district"){
              this_.cityId = this_.cityJson.data[index]["adcode"]
            }else {
              this_.cityId = this_.parentCode
            }
            let id = this_.cityId.toString().slice(0, 6)
            axios
                    .get("/json/map/" + id + ".json", {})
                    .then(response => {
                      parentId = response.data.features[0].properties.parent.adcode;
                    });
            //代表有下级地图
            axios
              .get("/json/map/" + this_.cityId + ".json", {})
              .then(response => {
                const mapJson = response.data;
                this.geoJson = mapJson;
                this_.registerAndsetOption(
                  myChart,
                  this_.cityId,
                  param.name,
                  mapJson,
                  true
                );
              });
          }
        });
      });
    },
    search(code) {
      for (let i = 0; i < this.cityJson.data.length; i++) {
        if (this.cityJson.data[i]["adcode"] === code) {
          this.cityId = (code.slice(2, 6) === "0000" || code.slice(4, 6) === "00") ? code + '_full' : code
          this.cityName = this.cityJson.data[i]["name"]
        }
      }
      this.getBackId(this.cityId)
      axios
        .get("/json/map/" + this.cityId + ".json", {})
        .then(response => {
          const mapJson = response.data;
          this.registerAndsetOption(
            myChart,
            this.cityId,
            this.cityName,
            mapJson,
            true
          );
        });
    },
    getBackId(id){
      id = id.toString().slice(0, 6)
      axios
        .get("/json/map/" + id + ".json", {})
        .then(response => {
          parentId =   response.data.features[0].properties.parent.adcode;
        });
    },
    getBackName(id){
      for (let i = 0; i < this.cityJson.data.length; i++) {
        if (id == this.cityJson.data[i].adcode) {
          this.backName = this.cityJson.data[i].name
        }
      }
    }
  }
};

</script>

<style>
body {
}
</style>

<style scoped>
.box {
  position: absolute;
  width: 100%;
  height: 100%;

}

.chart {
  position: relative;
  height: 100%;
}

</style>
